import { create } from 'zustand';
import type { Session } from '../types/tenant';
import type { Period } from '../types/metrics';

interface UIState {
  session: Session | null;
  isLoading: boolean;
  selectedPeriod: Period;
  sidebarCollapsed: boolean;
  sidebarOpen: boolean;
  selectedOrgId: string | null; // Dev users: org switcher
  selectedPlatformId: string | null; // Dev users: platform environment selector

  setSession: (session: Session | null) => void;
  setLoading: (loading: boolean) => void;
  setSelectedPeriod: (period: Period) => void;
  toggleSidebar: () => void;
  setSidebarOpen: (open: boolean) => void;
  setSelectedOrgId: (orgId: string | null) => void;
  setSelectedPlatformId: (platformId: string | null) => void;
}

export const useUIStore = create<UIState>((set) => ({
  session: null,
  isLoading: true,
  selectedPeriod: '24h',
  sidebarCollapsed: false,
  sidebarOpen: false,
  selectedOrgId: null,
  selectedPlatformId: null,

  setSession: (session) => set({ session }),
  setLoading: (isLoading) => set({ isLoading }),
  setSelectedPeriod: (selectedPeriod) => set({ selectedPeriod }),
  toggleSidebar: () => set((state) => ({ sidebarCollapsed: !state.sidebarCollapsed })),
  setSidebarOpen: (sidebarOpen) => set({ sidebarOpen }),
  setSelectedOrgId: (selectedOrgId) => set({ selectedOrgId }),
  setSelectedPlatformId: (selectedPlatformId) => set({ selectedPlatformId }),
}));
